import { IWizardConfig } from "../../../wizard/types";
import ContactForm from "../components/ContactForm";

export function useContactConfig(): IWizardConfig {
  return {
    steps: [
      {
        width: "411px",
        titleConfig: {
          titleText: "Contact Us",
        },
        content: ContactForm,
      },
    ],
    submitButtonText: null,
  };
}
